import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: /*@__PURE__*/_normalizeClass(['col-12', 'mb-4'])
}
const _hoisted_2 = {
  class: "card bg-white",
  style: {"border-radius":"10px"}
}
const _hoisted_3 = { class: "card-text" }
const _hoisted_4 = { class: "header mb-3" }
const _hoisted_5 = { class: "d-flex align-items-center gap-2" }
const _hoisted_6 = { class: "units" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center gap-2"
}
const _hoisted_8 = { class: "buttons d-flex flex-wrap mb-3" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "flex-grow-1 overflow-auto operationGrid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertComponent = _resolveComponent("AlertComponent")!
  const _component_OperationCreateComp = _resolveComponent("OperationCreateComp")!
  const _component_EditComponent = _resolveComponent("EditComponent")!
  const _component_MultiEditComponent = _resolveComponent("MultiEditComponent")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_GridLoading = _resolveComponent("GridLoading")!
  const _component_kendo_grid = _resolveComponent("kendo-grid")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.setCloneDialog)
      ? (_openBlock(), _createBlock(_component_AlertComponent, {
          key: 0,
          setCloneDialog: _ctx.setCloneDialog,
          onHideCloneDialog: _ctx.hideCloneDialog,
          onSetWindow: _ctx.showGridAfterClone,
          numberOfOperation: _ctx.selectedRowIds.length
        }, null, 8, ["setCloneDialog", "onHideCloneDialog", "onSetWindow", "numberOfOperation"]))
      : _createCommentVNode("", true),
    (_ctx.setDeleteDialog)
      ? (_openBlock(), _createBlock(_component_AlertComponent, {
          key: 1,
          setDeleteDialog: _ctx.setDeleteDialog,
          onHideDeleteDialog: _ctx.hideDeleteDialog,
          onSetWindow: _ctx.showGridAfterDelete,
          numberOfOperation: _ctx.selectedRowIds.length
        }, null, 8, ["setDeleteDialog", "onHideDeleteDialog", "onSetWindow", "numberOfOperation"]))
      : _createCommentVNode("", true),
    (_ctx.showPopup)
      ? (_openBlock(), _createBlock(_component_OperationCreateComp, {
          key: 2,
          showPopup: _ctx.showPopup,
          onVisibleDialog: _ctx.update,
          seamLengthUnit: _ctx.seamLengthUnit,
          ticketTex: _ctx.ticketTex,
          calculationEngineType: _ctx.calculationEngineType,
          isMultiComponentThreadEnabled: _ctx.isMultiComponentThreadEnabled,
          onGetOperationData: _ctx.setStylesData,
          consumptionData: _ctx.consumptionData
        }, null, 8, ["showPopup", "onVisibleDialog", "seamLengthUnit", "ticketTex", "calculationEngineType", "isMultiComponentThreadEnabled", "onGetOperationData", "consumptionData"]))
      : _createCommentVNode("", true),
    (_ctx.showEditPopup)
      ? (_openBlock(), _createBlock(_component_EditComponent, {
          key: 3,
          showEditPopup: _ctx.showEditPopup,
          onVisibleDialog: _ctx.hideEditWindow,
          operationId: _ctx.selectedRowIds[0],
          seamLengthUnit: _ctx.seamLengthUnit,
          calculationEngineType: _ctx.calculationEngineType,
          isMultiComponentThreadEnabled: _ctx.isMultiComponentThreadEnabled,
          ticketTex: _ctx.ticketTex,
          onGetOperationData: _ctx.setEditStylesData,
          onOperationId: _ctx.setOperationId,
          consumptionData: _ctx.consumptionData
        }, null, 8, ["showEditPopup", "onVisibleDialog", "operationId", "seamLengthUnit", "calculationEngineType", "isMultiComponentThreadEnabled", "ticketTex", "onGetOperationData", "onOperationId", "consumptionData"]))
      : _createCommentVNode("", true),
    (_ctx.multipleFormat)
      ? (_openBlock(), _createBlock(_component_MultiEditComponent, {
          key: 4,
          multipleFormat: _ctx.multipleFormat,
          selectedRowIds: _ctx.selectedRowIds,
          seamLengthUnit: _ctx.seamLengthUnit,
          calculationEngineType: _ctx.calculationEngineType,
          ticketTex: _ctx.ticketTex,
          selectedOperationCount: _ctx.selectedOperationCount,
          onShowGrid: _ctx.showGridAfterMultiEdit,
          consumptionData: _ctx.consumptionData,
          isMultiEditClicked: _ctx.isMultipleEdit
        }, null, 8, ["multipleFormat", "selectedRowIds", "seamLengthUnit", "calculationEngineType", "ticketTex", "selectedOperationCount", "onShowGrid", "consumptionData", "isMultiEditClicked"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["card-body", ['card-body', { fullscreen: _ctx.isMaximized }]])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createTextVNode(_toDisplayString(_ctx.$t("operationListComp.operationList")) + " ", 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("operationListComp.uom")) + ": " + _toDisplayString(_ctx.unitOfMeasurement) + " " + _toDisplayString(_ctx.$t("operationListComp.uop")) + ": " + _toDisplayString(_ctx.unitOfPackage) + " " + _toDisplayString(_ctx.ticketTex), 1)
              ]),
              (!_ctx.isMaximized)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-expand-alt",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.stylesData.length > 0 && _ctx.toggleMaximize())),
                      style: _normalizeStyle({
                    cursor: _ctx.stylesData.length === 0 ? 'default' : 'pointer',
                    opacity: _ctx.stylesData.length === 0 ? 0.4 : 1
                  })
                    }, null, 8, ["style"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  class: "btn btn-sm btn-primary button",
                  style: {"width":"5rem","text-align":"center"},
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleAdd && _ctx.handleAdd(...args))),
                  disabled: !_ctx.isAddButtonDisabled
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "fa fa-plus" }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t("operationListComp.add")), 1)
                ], 8, _hoisted_9),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-primary button",
                  style: {"width":"5rem","text-align":"center"},
                  disabled: (_ctx.isMaximized && !_ctx.multipleFormat && !_ctx.isMultipleEdit) || _ctx.disableButton,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editOperationFunction && _ctx.editOperationFunction(...args)))
                }, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", {
                    class: "fas fa-edit",
                    style: {"padding-right":"5px"}
                  }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t("operationListComp.edit")), 1)
                ], 8, _hoisted_10),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-primary button",
                  style: {"width":"6rem","text-align":"center"},
                  disabled: _ctx.disableButton,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setCloneDialog = true))
                }, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", {
                    class: "far fa-clone",
                    style: {"padding-right":"5px"}
                  }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t("operationListComp.duplicate")), 1)
                ], 8, _hoisted_11),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-primary button",
                  style: {"width":"6rem","text-align":"center"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setDeleteDialog = true)),
                  disabled: _ctx.disableButton
                }, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", {
                    class: "fa fa-trash",
                    style: {"padding-right":"5px"}
                  }, null, -1)),
                  _createTextVNode(_toDisplayString(_ctx.$t("operationListComp.delete")), 1)
                ], 8, _hoisted_12)
              ]),
              _createElementVNode("div", null, [
                (_ctx.loadingGrid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_GridLoading)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_kendo_grid, {
                        ref: "operationsGrid",
                        "data-source": _ctx.dataSource,
                        columns: _ctx.columns,
                        sortable: true,
                        "column-menu": !_ctx.isMaximized,
                        filterable: 
                      _ctx.isMaximized
                        ? {
                            mode: 'menu',
                            extra: false,
                            operators: {
                              string: {
                                contains: 'Contains'
                              }
                            }
                          }
                        : true
                    ,
                        reorderable: true,
                        selectable: 'multiple',
                        persistSelection: true,
                        "selected-field": _ctx.selectedField,
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChange($event))),
                        scrollable: false
                      }, null, 8, ["data-source", "columns", "column-menu", "filterable", "selected-field"])
                    ]))
              ])
            ])
          ])
        ], 2)
      ])
    ])
  ]))
}